import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import MostRecentContainer from "~/Containers/MostRecentContainer";
import Tile from "../../Components/Tile";
class RecentPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refresh: false,
    };
  }
  checkRecent = () => {
    this.setState({ refresh: true });
  };

  render() {
    const { refresh } = this.state;

    if (refresh) {
      this.setState({ refresh: false });
      return <Redirect to={`/`} />;
    }

    return (
      <div className="home-page-component">
        <Helmet>
          <title>____ of the Day | Dream Chimney</title>
          <link rel="canonical" href={`https://www.dreamchimney.com/oftheday/recent`} />
        </Helmet>
        <div className="pageTitle">Most Recent</div>
        <div className="home-component">
          <MostRecentContainer
            componentType={Tile}
            render={({ items, loadMore }) => (
              <div>
                <Row noGutters className="minimalGutter">
                  {items &&
                    items.map((item) => (
                      <Col xl={4} lg={6} xs={12} key={item.id}>
                        <Tile archive otd={item} />
                      </Col>
                    ))}
                </Row>
                <div>{loadMore}</div>
              </div>
            )}
          />
        </div>
      </div>
    );
  }
}

export default RecentPage;
